/* eslint-disable sonarjs/cognitive-complexity */
// 9fbef606107a605d69c0edbcd8029e5d
import { call, takeLatest, put, select } from 'redux-saga/effects';

import ADD_PICKUP_CONSTANTS from './AddPickUpPersonForm.constants';
import addPickUpPersonApi from '../../../../../../../services/abstractors/account/AddPickupPerson';
import {
  hideLoader,
  setAddPickupErrorMesssage,
  showErrorMessage,
  showLoader,
  showSuccessMessage,
} from './AddPickUpPersonForm.actions';
import { getOrderLookUpAPISwitch } from '../../../container/OrderDetails.selectors';
import { getOrderDetails } from '../../../container/OrderDetails.actions';
import { routeToPage } from '../../../../CustomerHelp/util/utility';
import internalEndpoints from '../../../../common/internalEndpoints';
import { getUserEmail } from '../../../../User/container/User.selectors';
import { isGuest } from '../../../../../CnC/Checkout/container/Checkout.selector';

function handleError(err) {
  if (err && (err.response || (err.errorResponse && err.errorMessage))) {
    return err.response ? err.response.body.errors[0] : err;
  }
  return null;
}

export function* submitPickUpPersonForm({ payload }) {
  try {
    const { fromTrackOrder, encryptedEmailAddress, fromAppTrackOrder } = payload;
    const userEmail = yield select(getUserEmail);

    if (payload) {
      yield put(showLoader());
      const storeid = payload?.storeId;
      const apiPayload = {
        orderId: payload?.orderId,
        emailId: payload?.emailId || userEmail,
        pickupPerson: payload.pickupPerson,
      };
      yield call(addPickUpPersonApi, storeid, apiPayload);
      const orderLookUpAPISwitch = yield select(getOrderLookUpAPISwitch);
      const isGuestUser = yield select(isGuest);
      const orderDetailsPayload = {
        orderId: payload?.orderId,
        emailId: payload?.emailId,
        isGuest: isGuestUser,
        isPastOrder: false,
        orderLookUpAPISwitch,
      };

      if (fromAppTrackOrder) {
        orderDetailsPayload.emailAddress = payload?.emailId;
      }
      yield put(getOrderDetails(orderDetailsPayload));
      const trackOrderRoutes = {
        asPath: `${internalEndpoints.trackOrder.path}/${payload?.orderId}/${encryptedEmailAddress}`,
        to: `${internalEndpoints.trackOrder.link}&orderId=${payload?.orderId}&email=${encryptedEmailAddress}`,
      };
      const routes = {
        asPath: `${internalEndpoints.orderPage.path}/${payload?.orderId}`,
        to: `${internalEndpoints.orderPage.link}&orderId=${payload?.orderId}`,
      };
      if (fromTrackOrder) {
        routeToPage(trackOrderRoutes);
      } else {
        routeToPage(routes);
      }
      yield put(showSuccessMessage(true));
    }
  } catch (err) {
    const { _error } = err.errorMessages || {};
    const errorMessage = _error || handleError(err);
    const errorPayload = {
      errorMessage,
      errorCode: err?.errorCodes,
    };
    yield put(showErrorMessage(true));
    yield put(setAddPickupErrorMesssage(errorPayload));

    yield null;
  } finally {
    yield put(hideLoader());
  }
}

export function* AddPickupPersonSaga() {
  yield takeLatest(ADD_PICKUP_CONSTANTS.ADD_PICKUP_PERSON, submitPickUpPersonForm);
}

export default AddPickupPersonSaga;
